/** Small display helpers shared by the Tests page modules. */

/**
 * Rows created by the App Integrity validation suite (Admin → App Integrity)
 * live in sandbox projects named "E2E Integrity Validation — DO NOT USE"
 * (ProjectId prefix E2EVAL). They are lab plumbing, not client work — the
 * Tests page hides them unless the "validation tests" toggle is on.
 */
export const isValidationRow = (row: { ProjectName?: string | null; ProjectId?: string | null }): boolean =>
  /e2e[\s-]*integrity|do not use/i.test(row.ProjectName ?? '')
  || /^E2EVAL/i.test(row.ProjectId ?? '');

export const formatBytesShort = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** "3m ago" / "2h ago" / "5d ago" / locale date beyond 30 days. */
export const timeAgo = (iso: string | Date | null | undefined): string => {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '—';
  const mins = Math.floor((Date.now() - then) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days <= 30) return `${days}d ago`;
  return new Date(then).toLocaleDateString();
};

export const formatDepthRange = (
  top: number | null | undefined,
  base: number | null | undefined,
): string => {
  if (top == null && base == null) return '—';
  const fmt = (v: number | null | undefined) => (v == null ? '?' : v.toFixed(2));
  return `${fmt(top)}–${fmt(base)} m`;
};
